import { FC } from "react";

import Modal from "../../../../components/Modal/Modal";
import AddClientPanel from "../AddClientPanel/AddClientPanel";
import { AddClientModalProps } from "./types";

import styles from "./AddClientModal.module.css";

const cls = (el?: string) => styles[el ? `add-client-modal__${el}` : "add-client-modal"];

const AddClientModal: FC<AddClientModalProps> = ({
  isOpen,
  onClose,
  ...panelProps
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className={cls()}>
        <h3 className={cls("title")}>Add Client</h3>
        <p className={cls("description")}>
          Link an existing account or create a new client to manage from your dashboard.
        </p>
        <AddClientPanel {...panelProps} isModal />
      </div>
    </Modal>
  );
};

export default AddClientModal;
